import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import asyncComponent from '../../util/asyncComponent';
import { PrivilegedRoute } from './util';
import {
  MODULE_INSPECTIONS,
  INSPECTIONS_CREATE,
  MODULE_MERCHANDISING,
  MERCHANDISING_REVIEWED_ITEMS,
  ADMIN_REPORTS_SALES,
  ADMIN_REPORTS_SAVED,
  MODULE_INVENTORY
} from '../../constants/Permissions';

const Routes = ({ match }) => {
  return (
    <Switch>
      <Route
        path={`${match.url}/*`}
        component={asyncComponent(() => import('./PlatformRedirectPage'))}
      />
      <PrivilegedRoute
        path={`${match.url}/inspection-list`}
        permission={MODULE_INSPECTIONS}
        component={asyncComponent(() => import('./InspectionListPage'))}
      />
      <PrivilegedRoute
        path={`${match.url}/inspection-create`}
        permission={INSPECTIONS_CREATE}
        component={asyncComponent(() => import('./InspectionCreatePage'))}
      />
      <PrivilegedRoute
        path={`${match.url}/inspections/:id/label`}
        permission={MODULE_INSPECTIONS}
        component={asyncComponent(() => import('./ProductItemLabelPage'))}
      />
      <PrivilegedRoute
        path={`${match.url}/scan/`}
        permission={MODULE_INSPECTIONS}
        component={asyncComponent(() => import('./ProductItemScanPage'))}
      />
      <PrivilegedRoute
        path={`${match.url}/merchandising-list`}
        permission={MODULE_MERCHANDISING}
        component={asyncComponent(() => import('./MerchandisingListPage'))}
      />
      <PrivilegedRoute
        path={`${match.url}/merchandising-review/:id`}
        permission={MODULE_MERCHANDISING}
        component={asyncComponent(() => import('./MerchandisingReviewPage'))}
      />
      <PrivilegedRoute
        path={`${match.url}/merchandising-list-unpublished`}
        permission={MERCHANDISING_REVIEWED_ITEMS}
        component={asyncComponent(() =>
          import('./MerchandisingListUnpublishedItemsPage')
        )}
      />
      <PrivilegedRoute
        path={`${match.url}/merchandising-list-published`}
        permission={MERCHANDISING_REVIEWED_ITEMS}
        component={asyncComponent(() =>
          import('./MerchandisingListPublishedItemsPage')
        )}
      />
      <PrivilegedRoute
        path={`${match.url}/merchandising-list-disposition`}
        permission={MERCHANDISING_REVIEWED_ITEMS}
        component={asyncComponent(() =>
          import('./MerchandisingListDispositionItemsPage')
        )}
      />
      <PrivilegedRoute
        path={`${match.url}/merchandising/published/:id`}
        permission={MERCHANDISING_REVIEWED_ITEMS}
        component={asyncComponent(() => import('./ProductItemDetailPage'))}
      />
      <PrivilegedRoute
        path={`${match.url}/merchandising/:id`}
        permission={MERCHANDISING_REVIEWED_ITEMS}
        component={asyncComponent(() => import('./MerchandisingDetailPage'))}
      />
      <PrivilegedRoute
        path={`${match.url}/inventory-current`}
        permission={MODULE_INVENTORY}
        component={asyncComponent(() => import('./InventoryCurrentPage'))}
      />
      <PrivilegedRoute
        path={`${match.url}/admin/reports/sales`}
        permission={ADMIN_REPORTS_SALES}
        component={asyncComponent(() => import('./admin/SalesReportPage'))}
      />
      <PrivilegedRoute
        path={`${match.url}/admin/reports/saved`}
        permission={ADMIN_REPORTS_SAVED}
        component={asyncComponent(() => import('./admin/SavedReportsPage'))}
      />
      <Route
        path={`${match.url}/no-access`}
        component={asyncComponent(() => import('./NoAccess'))}
      />
      <Route component={asyncComponent(() => import('./404Page'))} />
    </Switch>
  );
};

export default withRouter(Routes);
